export default [
  {
    path: '/admin/purchase-orders',
    name: 'purchase-order',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order')
  },
  {
    path: '/admin/purchase-orders/create',
    name: 'purchase-order-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order/create.vue')
  },
  {
    path: '/admin/purchase-orders/:id/edit',
    name: 'purchase-order-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order/edit.vue')
  }
]